import {
    AccountBox as AccountBoxIcon,
    DriveFolderUpload as DriveFolderUploadIcon,
    NotificationsNone as NotificationsNoneIcon,
    PostAdd as PostAddIcon,
    Agriculture as AgricultureIcon,
    Settings as SettingsIcon,
    Flag as FlagIcon,
} from '@mui/icons-material'

import FactoryIcon from '../../assets/icons/SVG/FactoryIcon'
import { UserGroups } from '../../models/Auth'
import { ROUTES } from '../utils/AppRoutes'
import { UserType } from '../utils/Types'

export type menuOptionsType = {
    icon: JSX.Element
    label: string
    path: string
    visible: boolean
}

export const menuOptions = (user: UserType): menuOptionsType[] => {
    return [
        {
            icon: <FactoryIcon />,
            label: 'Fábricas',
            path: ROUTES.MILLSLIST,
            visible:
                user.userGroups?.includes(UserGroups.MillsAdmin) ||
                user.userGroups?.includes(UserGroups.FinancialSupport),
        },
        {
            icon: <DriveFolderUploadIcon />,
            label: 'Importação',
            path: ROUTES.IMPORT,
            visible: user.userGroups?.includes(UserGroups.MillsAdmin),
        },
        {
            icon: <SettingsIcon />,
            label: 'Permissionamentos',
            path: ROUTES.APPPERMISSIONS,
            visible: user.userGroups?.includes(UserGroups.DsmAdmin),
        },
        {
            icon: <PostAddIcon />,
            label: 'Regras comerciais',
            path: ROUTES.COMMERCIALRULES,
            visible: user.userGroups?.includes(UserGroups.DsmAdmin),
        },
        {
            icon: <FlagIcon />,
            label: 'Feature Flags',
            path: ROUTES.FEATUREFLAGS,
            visible: user.userGroups?.includes(UserGroups.DsmAdmin),
        },
        {
            icon: <NotificationsNoneIcon />,
            label: 'Notificações Gerais',
            path: ROUTES.NEWS,
            visible: user?.isUserGroupsSTC,
        },
        {
            icon: <AccountBoxIcon />,
            label: 'Busca de Usuário',
            path: ROUTES.USERSEARCH,
            visible: user.userGroups?.includes(UserGroups.DsmAdmin),
        },
        {
            icon: <AgricultureIcon />,
            label: 'Busca de Cliente',
            path: ROUTES.CLIENTSEARCH,
            visible: user.userGroups?.includes(UserGroups.DsmAdmin),
        },
    ]
}
